import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { 
   getCurrentJourneyStep,
   getSelectedArtworkForJourneyStep
} from '../../selectors/journeyState-selectors'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import '../../css/JourneyStepProgress.css'

const JourneyStepProgressPanel = props => {
   const { artwork, journeyStep, getCurrentJourneyStep } = props
   let styleOverride = {}
   return (
      <div 
         className={'journey-nav-step small-3' + (journeyStep.id === getCurrentJourneyStep.id ? ' active' : '')} >
         <span className={'text-container'}>{journeyStep.name}</span>
         <div className={'artwork-slot'} style={styleOverride}>
            <ReactCSSTransitionGroup
               transitionName="artwork-panel-image"
               transitionEnterTimeout={600}
               transitionLeaveTimeout={200}>
               { artwork && 
                  <img 
                     className={`panel-thumbnail panel-${artwork.get('orientation')}`}
                     src={artwork.getIn(['artwork', 'small', 'url'])} 
                     alt={artwork.title}
                     key={`${journeyStep.id}-${artwork.id}`}
                  />
               }
            </ReactCSSTransitionGroup>
         </div>
      </div>
   )
}

const mapStateToProps = (state, ownProps) => ({
   artwork: getSelectedArtworkForJourneyStep(state, ownProps),
   getCurrentJourneyStep: getCurrentJourneyStep(state, ownProps),
   ...ownProps
})

const mapDispatchToProps = dispatch => bindActionCreators({
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(JourneyStepProgressPanel)


// WEBPACK FOOTER //
// ./src/components/JourneyStep/JourneyStepProgressPanel.js